import { render, staticRenderFns } from "./YqhxApp.vue?vue&type=template&id=a96a625e&scoped=true"
import script from "./YqhxApp.vue?vue&type=script&lang=js"
export * from "./YqhxApp.vue?vue&type=script&lang=js"
import style0 from "./YqhxApp.vue?vue&type=style&index=0&id=a96a625e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a96a625e",
  null
  
)

export default component.exports